import React, { useEffect, useRef, useState } from "react";
import Loading from "../Modals/Loading";
import customerService from "../Services/customerService";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../Components/DeleteModal";
import { HiOutlineTrash } from "react-icons/hi";
import { TiBusinessCard } from "react-icons/ti";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FiEdit3 } from "react-icons/fi";
import Head from "../Components/Head";
import {
  MdKeyboardDoubleArrowDown,
  MdKeyboardDoubleArrowUp,
} from "react-icons/md";
import { LuEye } from "react-icons/lu";
import PurchaseDetailsModal from "../Components/PurchaseDetailsModal";
import CustomerDetails from "../Modals/CustomerDetails";

const Customers = () => {
  const [user, setUser] = useState([]);
  const [loading, setLoading] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [open, setOpen] = useState(false);
  const [deleteID, setDeleteID] = useState();
  const topRef = useRef(null);
  const bottomRef = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const [seletedId, setSelectedId] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const getUsers = async () => {
      try {
        setLoading(true);
        const response = await customerService.fetchAll();
        setUser(response.customers);
        setLoading(false);
      } catch {}
    };
    getUsers();
  }, [trigger]);

  const initiateDelete = (id) => {
    setOpen(true);
    setDeleteID(id);
  };

  const handleDelete = () => {
    setDeleting(true);
    customerService.delete(deleteID).then(() => {
      setDeleting(false);
      setTrigger(!trigger);
    });
  };

  const handleStatus = (id, s) => {
    const status = s === "active" ? "inactive" : "active";
    customerService.status(id, { status }).then(() => {
      setTrigger(!trigger);
    });
  };

  const handleOpenModal = (id) => {
    setSelectedId(id);
    setOpenModal(true);
  };

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      <div ref={topRef} />
      <DeleteModal
        open={open}
        setOpen={setOpen}
        deleteFunction={handleDelete}
        deleting={deleting}
      />
      {loading ? (
        <Loading />
      ) : (
        <div className="flex flex-col">
          <Head
            heading={"Customers"}
            button_text={"Add Customer"}
            navigation={() => navigate("/customers/add")}
          />
          <div className="fixed bottom-10 right-10 flex flex-col gap-3 z-50">
            <button
              onClick={() =>
                topRef.current?.scrollIntoView({ behavior: "smooth" })
              }
              className="w-11 h-11 flex items-center justify-center rounded-full bg-white border border-gray-200 shadow-lg hover:shadow-xl hover:bg-gray-50 hover:-translate-y-1 transition-all duration-300 group"
              title="Scroll to Top"
            >
              <MdKeyboardDoubleArrowUp className="text-xl text-gray-600 group-hover:text-gray-900 transition-colors duration-300" />
            </button>
            <button
              onClick={() =>
                bottomRef.current?.scrollIntoView({ behavior: "smooth" })
              }
              className="w-11 h-11 flex items-center justify-center rounded-full bg-white border border-gray-200 shadow-lg hover:shadow-xl hover:bg-gray-50 hover:translate-y-1 transition-all duration-300 group"
              title="Scroll to Bottom"
            >
              <MdKeyboardDoubleArrowDown className="text-xl text-gray-600 group-hover:text-gray-900 transition-colors duration-300" />
            </button>
          </div>

          <div className="table-div">
            <table>
              <thead>
                <tr className="border-y-2 text-left w-full text-black font-bold text-[10px]">
                  <th className="w-[1%] py-4 pl-4">Sr no.</th>
                  <th className="w-[5%] py-4">Company Name</th>
                  <th className="w-[4%] py-4">Name</th>
                  <th className="w-[2%] py-4">Designation</th>
                  <th className="w-[1%] py-4 text-center">Orders</th>
                  <th className="w-[1%] py-4 text-center">Ledger</th>
                  <th className="w-[1%] py-4 text-center">License</th>
                  <th className="w-[1%] py-4 pl-4">Status</th>
                  <th className="w-[1%] py-4 text-center">Options</th>
                </tr>
              </thead>
              <tbody>
                {user?.map((data, index) => (
                  <tr
                    key={index}
                    className="bg-accent border-b border-gray-100 text-left"
                  >
                    <td className="py-4 font-bold text-blue-500 pl-4">
                      {index + 1}.
                    </td>
                    <td className="py-4 font-semibold overflow-hidden truncate">
                      {data.company_name}
                    </td>
                    <td className="py-2 text-primary pr-2">
                      <div className="flex flex-col">
                        <div>
                          {data.first_name} {data.last_name}
                        </div>
                        <div className="text-[10px] font-semibold opacity-85">
                          ({data.phone_number})
                        </div>
                      </div>
                    </td>
                    <td className="py-4 font-semibold">{data.designation}</td>
                    <td className="py-4 text-center">
                      <button
                        onClick={() => handleOpenModal(data.id)}
                        className="flex items-center justify-center duration-300 py-1 w-10 mx-auto"
                      >
                        <LuEye className="h-4 w-4 text-cyan-500" />
                      </button>
                    </td>
                    <td className="py-4 text-center">
                      <button
                        className="text-primary"
                        onClick={() =>
                          navigate(`/customers/ledger?id=${data.id}`)
                        }
                      >
                        <IoDocumentTextOutline className="h-4 w-4 text-amber-500" />
                      </button>
                    </td>
                    <td className="py-4">
                      <div className="flex justify-center">
                        {data.license ? (
                          <a
                            href={data.license}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 hover:underline"
                          >
                            <TiBusinessCard className="w-4 h-4" />
                          </a>
                        ) : (
                          <span>-</span>
                        )}
                      </div>
                    </td>
                    <td className="py-4 pl-4">
                      <div
                        className={`cursor-pointer uppercase font-semibold py-1 px-2 rounded-md text-center w-fit ${
                          data.status === "active"
                            ? "bg-green-500 bg-opacity-20 text-green-500"
                            : "bg-red-500 bg-opacity-20 text-red-500"
                        }`}
                        onClick={() => handleStatus(data.id, data.status)}
                      >
                        {data.status}
                      </div>
                    </td>
                    <td className="flex justify-center py-4">
                      <div className="flex flex-row gap-3">
                        <button
                          onClick={() =>
                            navigate(`/customers/edit?id=${data.id}`)
                          }
                        >
                          <FiEdit3 className="h-4 w-4 text-indigo-500" />
                        </button>
                        <button onClick={() => initiateDelete(data.id)}>
                          <HiOutlineTrash className="h-4 w-4 text-red-500" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div ref={bottomRef} />
      <CustomerDetails
        isOpen={openModal}
        id={seletedId}
        onClose={() => setOpenModal(false)}
      />
    </main>
  );
};

export default Customers;
